import script from "./SafetySectionGroupV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SafetySectionGroupV2.vue?vue&type=script&setup=true&lang=js"

import "./SafetySectionGroupV2.vue?vue&type=style&index=0&id=62ca4178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ca4178"]])

export default __exports__